export const API_URL = "https://car-ren-tal.herokuapp.com";
// export const API_URL = "http://localhost:8000";
